var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-block"},[_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],attrs:{"symbol":"info","size":"0 0 17 17","role":"info"}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }